<template>
  <Flex :direction="$screen === 's' ? 'column' : 'row'">
    <Flex :direction="$screen === 's' ? 'column' : 'row'">
      <BaseCard>
        <Flex
          direction="column"
          :gap="0.5"
          v-if="productCalculations"
        >
          <BaseHeading size="s">
            {{ $t('global.total_items') }}
          </BaseHeading>
          <BaseHeading v-test="'inventoryStatsTotalProducts'">
            {{ productCalculations.totalProducts }}
          </BaseHeading>
        </Flex>
        <BaseSpinner
          v-show="!productCalculations && $apollo.loading"
          inline
        />
      </BaseCard>
    </Flex>
    <Flex :direction="$screen === 's' ? 'column' : 'row'">
      <BaseCard>
        <Flex
          direction="column"
          :gap="0.5"
          v-if="productCalculations"
        >
          <BaseHeading size="s">
            {{ $t('global.total_inventory') }}
          </BaseHeading>
          <BaseHeading v-test="'inventoryStatsTotalValue'">
            {{ filters.currency(productCalculations.totalValue) }}
          </BaseHeading>
        </Flex>
        <BaseSpinner
          v-show="!productCalculations && $apollo.loading"
          inline
        />
      </BaseCard>
    </Flex>
  </Flex>
</template>

<script lang="ts">
import gql from 'graphql-tag';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import filters from '@/filters';
import { useLocationsStore } from '@/stores/locations';

export default defineComponent({
  props: {
    categoryIds: {
      type: Array,
      required: true,
    },
    supplierIds: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
      filters,
    };
  },
  data() {
    return {
      productCalculations: null,
    };
  },
  computed: {
    ...mapState(useLocationsStore, ['locationId']),
  },
  apollo: {
    productCalculations: {
      query: gql`
        query getProductCalculations(
          $locationId: ID
          $categoryIds: [Int!]
          $supplierIds: [Int!]
        ) {
          productCalculations(
            locationId: $locationId
            categoryIds: $categoryIds
            supplierIds: $supplierIds
          ) {
            totalProducts
            totalValue
          }
        }
      `,
      variables() {
        return {
          locationId: Number.parseInt(this.locationId),
          categoryIds: this.categoryIds,
          supplierIds: this.supplierIds,
        };
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    },
  },
});
</script>
